<template>
  <b-modal
    id="modal-representante-profile"
    ref="profileModal"
    size="lg"
    centered
    hide-header
    hide-footer
    modal-class="profile-modal-clean"
    content-class="profile-modal-content-clean"
    @hidden="onHidden"
  >
    <div class="profile-wrapper">
      <div class="profile-header">
        <div class="header-left">
          <!-- <div class="header-avatar">
            <feather-icon icon="UserIcon" size="16" />
          </div> -->
          <h3 class="header-title">Meu Perfil</h3>
          <span class="status-chip" :class="statusClass">
            {{ statusText }}
          </span>
        </div>
        <button type="button" class="close-btn" @click="closeModal" aria-label="Fechar">
          <feather-icon icon="XIcon" size="16" />
        </button>
      </div>

      <div class="profile-body">
        <div class="profile-summary">
          <div class="summary-avatar">
            <feather-icon icon="UserIcon" size="24" />
          </div>
          <div class="summary-info">
            <span class="summary-name">{{ representanteNome }}</span>
            <span class="summary-email">{{ userData.email || '-' }}</span>
          </div>
        </div>

        <div class="profile-section">
          <div class="section-title">
            <feather-icon icon="UserIcon" size="14" />
            <span>Dados do Usuário</span>
          </div>
          <div class="fields-grid">
            <div class="field-item">
              <label class="field-label">Código</label>
              <div class="field-value">{{ representanteId || '-' }}</div>
            </div>
            <!-- <div class="field-item">
              <label class="field-label">Nome Abreviado</label>
              <div class="field-value">{{ representanteNomeAbreviado || '-' }}</div>
            </div> -->
            <div class="field-item">
              <label class="field-label">E-mail</label>
              <div class="field-value">{{ userData.email || '-' }}</div>
            </div>
            <!-- <div class="field-item">
              <label class="field-label">Telefone</label>
              <div class="field-value">{{ telefone || '-' }}</div>
            </div> -->
          </div>
        </div>

        <!-- <div class="profile-section">
          <div class="section-title">
            <feather-icon icon="BriefcaseIcon" size="14" />
            <span>Estabelecimento</span>
          </div>
          <div class="fields-grid">
            <div class="field-item">
              <label class="field-label">Código Estab.</label>
              <div class="field-value">{{ estabelecimento || '-' }}</div>
            </div>
            <div class="field-item">
              <label class="field-label">Razão Social</label>
              <div class="field-value">{{ razaoSocial || '-' }}</div>
            </div>
          </div>
        </div> -->

        <div class="profile-section">
          <div class="section-title">
            <feather-icon icon="ShieldIcon" size="14" />
            <span>Acesso</span>
          </div>
          <div class="fields-grid cols-3">
            <div class="field-item">
              <label class="field-label">Perfil de Acesso</label>
              <div class="field-value">{{ perfilAcesso || '-' }}</div>
            </div>
            <!-- <div class="field-item">
              <label class="field-label">UF</label>
              <div class="field-value">{{ uf || '-' }}</div>
            </div>
            <div class="field-item">
              <label class="field-label">Comissão</label>
              <div class="field-value">{{ comissao || '-' }}</div>
            </div> -->
          </div>
        </div>

        <div class="profile-section" v-if="endereco">
          <div class="section-title">
            <feather-icon icon="MapPinIcon" size="14" />
            <span>Endereço</span>
          </div>
          <div class="fields-grid cols-1">
            <div class="field-item">
              <div class="field-value">{{ endereco }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="profile-footer">
        <button type="button" class="btn-secondary" @click="closeModal">
          Fechar
        </button>
        <button type="button" class="btn-primary" @click="copyProfileData">
          <feather-icon icon="CopyIcon" size="14" />
          Copiar dados
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  name: 'RepresentanteProfileModal',
  components: {
    BModal,
  },
  computed: {
    userData() {
      try {
        const data = JSON.parse(localStorage.getItem('userData'));
        return data?.userData || data || {};
      } catch {
        return {};
      }
    },
    perfilLogado() {
      try {
        return JSON.parse(localStorage.getItem('perfilLogado')) || {};
      } catch {
        return {};
      }
    },
    representanteId() {
      return this.userData.representanteid || this.userData.id || '';
    },
    representanteNome() {
      return this.userData.nome || this.userData.representantenome || 'Usuário';
    },
    representanteNomeAbreviado() {
      return this.userData.representantenomeabreviado || this.userData.nomeabreviado || '';
    },
    estabelecimento() {
      return this.userData.estabelecimentoid || this.perfilLogado.estabelecimentoid || '';
    },
    razaoSocial() {
      return this.userData.razaosocial || this.perfilLogado.razaosocial || '';
    },
    perfilAcesso() {
      return this.perfilLogado.perfil_acesso_nome || '';
    },
    uf() {
      return this.userData.ufid || this.userData.uf || '';
    },
    telefone() {
      return this.userData.representantetelefone || this.userData.telefone || '';
    },
    comissao() {
      const val = this.userData.representantepercentualcomissao;
      return val !== undefined && val !== null ? `${val}%` : '';
    },
    endereco() {
      const parts = [
        this.userData.representanteendereco,
        this.userData.representantebairro,
        this.userData.representantecidade,
        this.userData.ufid,
      ].filter(Boolean);
      return parts.length > 0 ? parts.join(', ') : '';
    },
    statusClass() {
      const ativo = this.userData.representanteativo !== 0 && this.userData.representanteativo !== false;
      return ativo ? 'status-active' : 'status-inactive';
    },
    statusText() {
      const ativo = this.userData.representanteativo !== 0 && this.userData.representanteativo !== false;
      return ativo ? 'Ativo' : 'Inativo';
    },
  },
  methods: {
    openModal() {
      this.$refs.profileModal.show();
    },
    closeModal() {
      this.$refs.profileModal.hide();
    },
    onHidden() {
    },
    copyProfileData() {
      const text = [
        `Código: ${this.representanteId}`,
        `Nome: ${this.representanteNome}`,
        `Nome Abreviado: ${this.representanteNomeAbreviado || '-'}`,
        `E-mail: ${this.userData.email || '-'}`,
        `Telefone: ${this.telefone || '-'}`,
        this.estabelecimento ? `Estabelecimento: ${this.estabelecimento}` : '',
        this.razaoSocial ? `Razão Social: ${this.razaoSocial}` : '',
        this.perfilAcesso ? `Perfil: ${this.perfilAcesso}` : '',
        this.uf ? `UF: ${this.uf}` : '',
        this.comissao ? `Comissão: ${this.comissao}` : '',
        this.endereco ? `Endereço: ${this.endereco}` : '',
      ].filter(Boolean).join('\n');

      navigator.clipboard.writeText(text).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Copiado!',
            text: 'Dados do perfil copiados para a área de transferência',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Não foi possível copiar os dados',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
    },
  },
};
</script>

<style lang="scss">
.profile-modal-clean {
  .modal-dialog {
    max-width: 600px;
  }

  .modal-content {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  }

  .modal-body {
    padding: 0;
  }
}

.profile-wrapper {
  background: #fff;
  color: #1e293b;
}

.profile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

.header-avatar {
  width: 32px;
  height: 32px;
  background: #6366f1;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #fff;
  }
}

.header-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.1875rem 0.5rem;
  border-radius: 4px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;

  &.status-active {
    background: rgba(34, 197, 94, 0.12);
    color: #16a34a;
  }

  &.status-inactive {
    background: rgba(239, 68, 68, 0.12);
    color: #dc2626;
  }
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  color: #64748b;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }
}

.profile-body {
  padding: 1.25rem;
}

.profile-summary {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.875rem;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 1.25rem;
}

.summary-avatar {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: #fff;
  }
}

.summary-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.summary-name {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-email {
  font-size: 0.8125rem;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-section {
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0.625rem;
  padding-bottom: 0.375rem;
  border-bottom: 1px solid #e5e7eb;

  svg {
    color: #94a3b8;
  }
}

.fields-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;

  &.cols-1 {
    grid-template-columns: 1fr;
  }

  &.cols-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}

.field-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.field-label {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin: 0;
}

.field-value {
  padding: 0.5rem 0.75rem;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #1e293b;
  min-height: 34px;
  display: flex;
  align-items: center;
}

.profile-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.625rem;
  padding: 0.875rem 1.25rem;
  border-top: 1px solid #e5e7eb;
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
  }
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  border: none;
  background: #6366f1;
  color: #fff;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #5457e5;
  }
}

@media (max-width: 640px) {
  .profile-modal-clean .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }

  .fields-grid {
    grid-template-columns: 1fr;

    &.cols-3 {
      grid-template-columns: 1fr;
    }
  }

  .header-left {
    gap: 0.5rem;
  }

  .header-title {
    font-size: 0.875rem;
  }

  .profile-footer {
    flex-direction: column-reverse;

    .btn-secondary,
    .btn-primary {
      width: 100%;
      justify-content: center;
    }
  }
}

// Tema Escuro
body.dark-layout {
  .profile-modal-clean .modal-content {
    border-color: rgba(148, 163, 184, 0.15);
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  }

  .profile-wrapper {
    background: #1e293b;
    color: #e2e8f0;
  }

  .profile-header {
    border-bottom-color: rgba(148, 163, 184, 0.15);
  }

  .header-title {
    color: #e2e8f0;
  }

  .status-chip {
    &.status-active {
      background: rgba(34, 197, 94, 0.2);
      color: #4ade80;
    }

    &.status-inactive {
      background: rgba(239, 68, 68, 0.2);
      color: #f87171;
    }
  }

  .close-btn {
    background: rgba(51, 65, 85, 0.3);
    border-color: rgba(148, 163, 184, 0.2);
    color: #94a3b8;

    &:hover {
      background: rgba(51, 65, 85, 0.6);
      color: #e2e8f0;
      border-color: rgba(148, 163, 184, 0.3);
    }
  }

  .profile-summary {
    background: rgba(51, 65, 85, 0.4);
    border-color: rgba(148, 163, 184, 0.15);
  }

  .summary-name {
    color: #e2e8f0;
  }

  .summary-email {
    color: #94a3b8;
  }

  .section-title {
    color: #94a3b8;
    border-bottom-color: rgba(148, 163, 184, 0.15);

    svg {
      color: #64748b;
    }
  }

  .field-label {
    color: #94a3b8;
  }

  .field-value {
    background: rgba(51, 65, 85, 0.4);
    border-color: rgba(148, 163, 184, 0.15);
    color: #e2e8f0;
  }

  .profile-footer {
    border-top-color: rgba(148, 163, 184, 0.15);
  }

  .btn-secondary {
    background: rgba(51, 65, 85, 0.3);
    border-color: rgba(148, 163, 184, 0.25);
    color: #e2e8f0;

    &:hover {
      background: rgba(51, 65, 85, 0.6);
      border-color: rgba(148, 163, 184, 0.4);
    }
  }

  .btn-primary {
    background: #6366f1;
    color: #fff;

    &:hover {
      background: #5457e5;
    }
  }
}
</style>
